import { render, staticRenderFns } from "./Particles.vue?vue&type=template&id=3daa14d9&"
var script = {}
import style0 from "./Particles.vue?vue&type=style&index=0&id=3daa14d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports